// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}


.cursor {
  cursor: pointer;
}


.chat-container table {
  width: 100%;
  border-collapse: collapse;
}

.chat-container th,
.chat-container td {
  border: 1px solid #ddd;
  padding: 8px;
}

.chat-container th {
  background-color: #f4f4f4;
  text-align: left;
}


.markdown-container {
  max-width: 100%; /* Ensure it doesn't overflow the chat box */
  overflow-x: auto; /* Enable horizontal scrolling */
  padding: 8px; /* Optional: for better spacing */
}

.markdown-container table {
  width: 100%; /* Optional: allow table to scale */
  border-collapse: collapse;
}

.markdown-container th,
.markdown-container td {
  border: 1px solid #ddd;
  padding: 8px;
}

.markdown-container th {
  background-color: #f4f4f4;
  text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;;AAGA;EACE,eAAe;AACjB;;;AAGA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;;AAGA;EACE,eAAe,EAAE,4CAA4C;EAC7D,gBAAgB,EAAE,gCAAgC;EAClD,YAAY,EAAE,iCAAiC;AACjD;;AAEA;EACE,WAAW,EAAE,mCAAmC;EAChD,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n\n.cursor {\n  cursor: pointer;\n}\n\n\n.chat-container table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.chat-container th,\n.chat-container td {\n  border: 1px solid #ddd;\n  padding: 8px;\n}\n\n.chat-container th {\n  background-color: #f4f4f4;\n  text-align: left;\n}\n\n\n.markdown-container {\n  max-width: 100%; /* Ensure it doesn't overflow the chat box */\n  overflow-x: auto; /* Enable horizontal scrolling */\n  padding: 8px; /* Optional: for better spacing */\n}\n\n.markdown-container table {\n  width: 100%; /* Optional: allow table to scale */\n  border-collapse: collapse;\n}\n\n.markdown-container th,\n.markdown-container td {\n  border: 1px solid #ddd;\n  padding: 8px;\n}\n\n.markdown-container th {\n  background-color: #f4f4f4;\n  text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
